import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {StorageKeys} from 'src/app/share/enums/storage.enum';
import {CommonService} from 'src/app/share/services/common/common.service';
import {RolesService} from 'src/app/share/services/roles-service/roles.service';
import {StorageService} from 'src/app/share/services/storage-service/storage.service';

@Component({
  selector: 'app-edit-role',
  templateUrl: './edit-role.component.html',
  styleUrls: ['./edit-role.component.scss'],
})
export class EditRoleComponent {
  @Input() roleId             : any;
  @Input() selectedCompanyId  : string;
  @Input() randomID           : any;
  @Output() closePanel        : EventEmitter<any> = new EventEmitter<any>();

  permissionList              : any = [];
  ownPermissionList           : any = [];
  isShow                      : any[] = [];
  companyId                   : any;
  errorMsg                    : any;
  roleName                    : FormControl = new FormControl('', [Validators.required]);
  isRoleEdit                  : boolean = false;
  isValid                     : boolean = true;
  verifyLoader                : boolean = false;

  constructor(
    private readonly roleService     : RolesService,
    private readonly storageService  : StorageService,
    private readonly route           : Router,
    public commonService    : CommonService,
  ) { }

  ngOnInit(): void {
    let selfDetailsData = this.storageService.getDataFromLocalStorage(
      StorageKeys.SELF_DETAILS
    );
    if (selfDetailsData && !this.companyId) {
      this.companyId = selfDetailsData.company;
    }
    if (this.roleId) {
      this.isRoleEdit = true;
      this.isValid = false
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(!this.isRoleEdit){
      this.getPermissionsList();
      this.roleName.reset();
    }
    this.isShow = [];
    this.errorMsg = '';
    this.roleId = '';
    this.isRoleEdit = false;
    if (changes['roleId']?.currentValue) {
      this.getPermissionsList();
      this.roleId = changes['roleId']?.currentValue;
      if (this.roleId) {
        this.isRoleEdit = true;
      }
    }
    if (changes['selectedCompanyId']?.currentValue) {
      this.companyId = changes['selectedCompanyId']?.currentValue
    }
  }

  getPermissionMappingName(permission: any, key: any) {
    return ((permission?.subPermissionsLabels?.[key]) || key).toString();

  }

  getPermissionsList() {
    this.roleService.getPermissionsList().subscribe({
     next: (res: any) => {
      if (res.status) {
        this.permissionList = res.data;

        if (this.roleId) {
          this.getRoleDataById(this.roleId);
        }

        for (const permission of this.permissionList) {
          permission.enabled = false;
          permission.some = 'Active';

          this.ownPermissionList.push({
            enabled: false,
            module: permission?.module,
          });

          switch (permission?.module) {
            case 'user':
            case 'user-key':
              permission.icon = '../../../assets/Images/roles-responsibilities/user.svg';
              break;
            case 'company':
            case 'company-structure':
              permission.icon = '../../../assets/Images/roles-responsibilities/orgstructure.svg';
              break;
            case 'company-contacts':
            case 'company-preference':
              permission.icon = '../../../assets/Images/roles-responsibilities/network.svg';
              break;
            case 'permission':
            case 'package':
              permission.icon = '../../../assets/Images/roles-responsibilities/packages.svg';
              break;
            case 'e-sign-details':
              permission.icon = '../../../assets/Images/roles-responsibilities/esign.svg';
              break;
            case 'role':
              permission.icon = '../../../assets/Images/roles-responsibilities/roles.svg';
              break;
            case 'dashboard':
              permission.icon = '../../../assets/Images/roles-responsibilities/dashboard.svg';
              break;
            case 'document':
              permission.icon = '../../../assets/Images/roles-responsibilities/docvault.svg';
              break;
            case 'lr':
            default:
              permission.icon = '../../../assets/Images/roles-responsibilities/loadreceipt.svg';
              break;
          }
        }
      }
    }
    });
  }

  isSubPermissionsEnabled(existingPermission: any, permission: any, i: number){
    const subPermissionList =
      existingPermission.subPermissions &&
      Object.keys(existingPermission.subPermissions);

    if (
      subPermissionList &&
      existingPermission.module === permission.module
    ) {
      permission.isShow = true;
      permission.some = 'Deactive';
      permission.isSubPermissions = true;
      const existSubPermissionList = permission.subPermissions;
      for (const key in existSubPermissionList) {
        if (subPermissionList.includes(key)) {
          existSubPermissionList[key] = true;
        }
      }
      permission.enabled = false;
      permission.isSubPermissions = existingPermission;
      this.ownPermissionList[i] = {
        module: permission.module,
        enabled: false,
        subPermissions: existSubPermissionList,
      };
    } else if(!permission.some) {
      permission.some = 'Active';
    }
  }
  //get Role By Id for view and edit
  getRoleDataById(id: any) {
    this.roleService.getRolesById(id).subscribe({
      next: (res: any) => {
        let existingPermissionList = res.data.permissions;
        this.roleName.patchValue(res.data.name);
        for (const existingPermission of existingPermissionList) {
          for (const [i, permission] of this.permissionList.entries()) {
            if (existingPermission.enabled && existingPermission.module === permission.module) {
              permission.enabled = true;
              permission.isSubPermissions = false;
              this.ownPermissionList[i] = {
                module: this.permissionList[i]?.module,
                enabled: true,
              };
            } else {
              this.isSubPermissionsEnabled(existingPermission, permission, i);
            }
          }
        }
      }
    });
  }

  handleOnClickClose() {
    this.closePanel.emit(false);
  }

  handleSubPermissionChange(event: any, index: number) {
    this.ownPermissionList[index]['subPermissions'] = {
      ...this.ownPermissionList[index]['subPermissions'],
      [event.name]: event.event.target.checked,
    };

    let condition = true;

    for (const permission of this.ownPermissionList) {
      const subPermissions = permission.subPermissions;

      if (permission.enabled || (subPermissions && Object.values(subPermissions).some(value => value === true))) {
        condition = false;
      }
    }

    this.isValid = condition;
  }

//on change of full,some,none
  changeSelection(event: any, i: any, permission: any) {
    const { value } = event.target;
    if (value !== 'none') {
      this.ownPermissionList[i] = {
        module: this.permissionList[i]?.module,
        enabled: value === 'full',
      };
    } else {
      this.ownPermissionList[i] = {
        enabled: false,
        module: this.permissionList[i]?.module,
      };
    }
    let condition = true;
    for (const permission of this.ownPermissionList) {
      const subPermissions = permission.subPermissions;
      if (permission.enabled || (subPermissions && Object.values(subPermissions).some(value => value === true))) {
        condition = false;
      }
      this.isValid = condition;
    }
    permission.isShow= event.target.value === 'some'
  }

  createRole() {
    this.verifyLoader = true;
    if (this.roleName.status !== 'VALID') {
      this.errorMsg = 'Role name required';
      this.verifyLoader = false;
      return;
    }
    const tempVariable = [];
    for (const permission of this.ownPermissionList) {
      permission && tempVariable.push(permission);
    }
    this.ownPermissionList = tempVariable;
    if (this.roleId) {
      const obj = {
        name: this.roleName.value,
        permissions: this.ownPermissionList,
      };

      this.roleService.updateRole(this.roleId, obj, this.companyId).subscribe({
        next: (response: any) => {
          if (response['status'] == 'success') {
            this.closePanel.emit(true);
            this.verifyLoader = false;
          }
        },
        error: (error: any) => {
          this.errorMsg = error?.error?.message;
          this.verifyLoader = false;
        },
      });
    } else {
      const obj = {
        name: this.roleName.value,
        permissions: this.ownPermissionList,
      };

      this.roleService.createPermission(obj, this.companyId)?.subscribe({
        next: (response: any) => {
          if (response['status'] == 'success') {
            this.closePanel.emit(true);
            this.verifyLoader = false;
          }
        },
        error: (error: any) => {
          this.errorMsg = error?.error?.message;
          this.verifyLoader = false;
        },
      });
    }
  }

  get isEnable() {
    return !this.roleName.value
  }

  protected readonly String = String;

}
